import { useCallback, useState } from 'react';
import { salesApi } from '../services/sales.service';
import { getSalesApiErrorMessage } from '../utils/sales/api-error-message';

const FALLBACK = 'No se pudo actualizar la fecha de venta.';

/**
 * Shared loading/error/submit for commercial sale-date corrections
 * (table action + order details).
 */
export function useEditSaleDate(onSuccess?: (orderId: number) => void | Promise<void>) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const clearError = useCallback(() => setError(null), []);

  const save = useCallback(
    async (orderId: number, saleDateIso: string): Promise<boolean> => {
      setLoading(true);
      setError(null);
      try {
        await salesApi.updateSalesOrderSaleDate(orderId, saleDateIso);
        await onSuccess?.(orderId);
        return true;
      } catch (err: unknown) {
        setError(getSalesApiErrorMessage(err, FALLBACK));
        return false;
      } finally {
        setLoading(false);
      }
    },
    [onSuccess],
  );

  return { loading, error, setError, clearError, save };
}
